export default __webpack_public_path__ + "static/media/phone.acb146ce.svg";